<template>
  <section class="banner-section">
    <svg
      id="e1uyo3geug4f1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 2000 700"
      shape-rendering="geometricPrecision"
      text-rendering="geometricPrecision"
    >
      <defs>
        <linearGradient
          id="e1uyo3geug4f2-fill"
          x1="949.376700"
          y1="218.006300"
          x2="2075.531300"
          y2="218.006300"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            id="e1uyo3geug4f2-fill-0"
            offset="0%"
            stop-color="rgb(212,51,93)"
          />
          <stop
            id="e1uyo3geug4f2-fill-1"
            offset="100%"
            stop-color="rgb(255,86,39)"
          />
        </linearGradient>
      </defs>
      <path
        id="e1uyo3geug4f2"
        d="M2049.500000,377.500000C2021.500000,485.500000,1893.300000,615.200000,1749.500000,616.500000C1617.300000,617.700000,1443,530,1406,377C1377.800000,260.500000,1176.500000,338.500000,1053,254C848.700000,114.200000,1009.500000,-152.500000,1009.500000,-152.500000L2075.500000,-180.500000C2075.500000,-180.500000,2077.500000,269.500000,2049.500000,377.500000Z"
        fill="url(#e1uyo3geug4f2-fill)"
        stroke="none"
        stroke-width="1"
      />
      <!-- <g id="e1uyo3geug4f3" opacity="0.3">
        <path
          id="e1uyo3geug4f4"
          d="M290.400000,162.800000L249.900000,122.300000C248.100000,120.500000,245.300000,120.500000,243.500000,122.300000L241.400000,124.400000C239.600000,126.200000,239.600000,129,241.400000,130.800000L281.900000,171.300000C283.700000,173.100000,286.500000,173.100000,288.300000,171.300000L290.400000,169.200000C292.100000,167.500000,292.100000,164.600000,290.400000,162.800000Z"
          fill="rgb(1,198,175)"
          stroke="none"
          stroke-width="1"
        />
        <path
          id="e1uyo3geug4f5"
          d="M281.800000,122.300000L241.300000,162.800000C239.500000,164.600000,239.500000,167.400000,241.300000,169.200000L243.400000,171.300000C245.200000,173.100000,248,173.100000,249.800000,171.300000L290.300000,130.800000C292.100000,129,292.100000,126.200000,290.300000,124.400000L288.200000,122.300000C286.500000,120.600000,283.600000,120.600000,281.800000,122.300000Z"
          fill="rgb(1,198,175)"
          stroke="none"
          stroke-width="1"
        />
      </g> -->
      <!-- <g id="e1uyo3geug4f6" opacity="0.3">
        <path
          id="e1uyo3geug4f7"
          d="M369.400000,622.800000L328.900000,582.300000C327.100000,580.500000,324.300000,580.500000,322.500000,582.300000L320.400000,584.400000C318.600000,586.200000,318.600000,589,320.400000,590.800000L360.900000,631.300000C362.700000,633.100000,365.500000,633.100000,367.300000,631.300000L369.400000,629.200000C371.100000,627.500000,371.100000,624.600000,369.400000,622.800000Z"
          fill="rgb(81,155,244)"
          stroke="none"
          stroke-width="1"
        />
        <path
          id="e1uyo3geug4f8"
          d="M360.800000,582.300000L320.300000,622.800000C318.500000,624.600000,318.500000,627.400000,320.300000,629.200000L322.400000,631.300000C324.200000,633.100000,327,633.100000,328.800000,631.300000L369.300000,590.800000C371.100000,589,371.100000,586.200000,369.300000,584.400000L367.200000,582.300000C365.500000,580.600000,362.600000,580.600000,360.800000,582.300000Z"
          fill="rgb(81,155,244)"
          stroke="none"
          stroke-width="1"
        />
      </g>
      <circle
        id="e1uyo3geug4f9"
        r="24.629981"
        transform="matrix(1 0 0 1 201.51942796999984 374.62998100000004)"
        fill="none"
        stroke="rgb(255,238,164)"
        stroke-width="10"
        stroke-miterlimit="10"
      />
      <rect
        id="e1uyo3geug4f10"
        width="32"
        height="32"
        rx="0"
        ry="0"
        transform="matrix(0.93970000000000 -0.34200000000000 0.34200000000000 0.93970000000000 -69.71067000000028 10.94399999999990)"
        opacity="0.4"
        fill="none"
        stroke="rgb(234,17,59)"
        stroke-width="10"
        stroke-miterlimit="10"
      /> -->
    </svg>
  </section>
</template>

<script>
export default {
  name: 'Template',
  components: {},
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner-section {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/index/bannerSection.vue